import { observer } from 'owa-mobx-react';
import React from 'react';
import classnames from 'owa-classnames';
import type { AppPaneUnderlayViewState } from '../store/schema/AppPaneUnderlayViewState';
import isAppPaneUnderlayExpanded from '../utils/isAppPaneUnderlayExpanded';
import isAppPaneUnderlayPlaceholder from '../utils/isAppPaneUnderlayPlaceholder';
import isAppPaneUnderlayShrinkable from '../utils/isAppPaneUnderlayShrinkable';
import { underlay as underlayStyle, shrinkable, placeholder } from './AppPaneUnderlay.scss';

export interface AppPaneUnderlayProps {
    underlay: AppPaneUnderlayViewState | undefined;
}
const AppPaneUnderlay: React.FunctionComponent<AppPaneUnderlayProps> = observer(
    function AppPaneUnderlay({ underlay }: AppPaneUnderlayProps) {
        return isAppPaneUnderlayExpanded(underlay) ? (
            <div
                className={classnames(
                    underlayStyle,
                    isAppPaneUnderlayShrinkable(underlay) && shrinkable,
                    isAppPaneUnderlayPlaceholder(underlay) && placeholder
                )}
            />
        ) : null;
    },
    'AppPaneUnderlay'
);

export default AppPaneUnderlay;
